import React from 'react'

const About =()=>{

    return (
        <React.Fragment>
            About
        </React.Fragment>
    )
}

export default About;